import React from "react";
import I18n from "../../i18n/I18n";
import styles from "./StoreProfile.scss";

type Props = {
    seller: Object,
    user: Object
}

const StoreProfile = (props: Props) => {
    const seller = props.seller;
    const user = props.user;

  return (
    <div className={styles.wrapper}>
        <div className={styles.ctr}>
            <div className={styles.box}>
                <span className={styles.bold}>
                    {I18n.getText("settings.heading-user-profile", {}, "User Profile")}
                </span>
                &nbsp;
                <span className={styles.badge}>
                    {I18n.getText("settings.verified", {}, "Verified")}
                </span>
            </div>
            <div className={styles.box}>
                <p className={styles.header}>
                    {I18n.getText("settings.user-name", {}, "User Name")}
                </p>
                <p className={styles.bold}>
                    { user.firstName}&nbsp;{user.lastName}
                </p>
            </div>
            <div className={styles.box}>
                <p className={styles.header}>
                    {I18n.getText("settings.user-email", {}, "Email")}
                </p>
                <p className={styles.bold}>
                    { user.email }
                </p>
            </div>
            {user.phone &&
                <div className={styles.box}>
                    <p className={styles.header}>
                        {I18n.getText("settings.user-phone", {}, "Contact Number")}
                    </p>
                    <p className={styles.bold}>
                        {user.phone}
                    </p>
                </div>
            }
            <div className={styles.box}>
                <p className={styles.header}>
                    {I18n.getText("settings.store-name", {}, "Store Name")}
                </p>
                <p className={styles.bold}>
                    { seller.storeName }
                </p>
            </div>
            <div className={styles.box}>
                <p className={styles.header}>
                    {I18n.getText("settings.store-currency", {}, "Default Currency")}
                </p>
                <p className={styles.bold}>
                    { seller.country_code !== "SA"
                        ? seller.currency_code
                        : seller.currency_code
                    }
                </p>
            </div>
            <div className={styles.box}>
                <p className={styles.header}>
                    {I18n.getText("settings.store-name-legal", {}, "Store Legal Name")}
                </p>
                <p className={styles.bold}>
                    { seller.legal_name }
                </p>
            </div>
            <div className={styles.box}>
                <p className={styles.header}>
                    {I18n.getText("settings.store-status", {}, "Status")}
                </p>
                <p className={styles.bold}>
                    { seller.store_status}
                </p>
            </div>
        </div>
    </div>
  );
};

export default StoreProfile;



// WEBPACK FOOTER //
// ./src/components/settings/StoreProfile.js